import React from 'react';
import { useNavigate } from 'react-router-dom';

import HomeImg from '../assets/home.svg';
import BackArrow from '../assets/backArrow.svg';

import '../css/HomeButton.scss';

export default function HomeButton({content, type}) {
    const navigate = useNavigate();

    let returnHome = false;
    if(type === 'return') {
        returnHome = true;
    }

    const goHome = () => {
        navigate('/');
    }
    return (
        <>
            {returnHome && 
                <div className="home-btn flex-container" onClick={goHome}>
                    <img src={BackArrow} className='home-btn-return' alt='white left facing arrow'/>
                    <img src={HomeImg} className='home-btn-img' alt='blue house icon'/>
                    <p className='home-btn-content'>{content}</p>
                </div>
            }
            {!returnHome && 
                <div className="home-btn flex-container" onClick={console.log({content, type})}>
                    <img src={HomeImg} className='home-btn-img' alt='blue house icon'/>
                    <p className='home-btn-content'>{content}</p>
                </div>
            }
        </>
    )
}